import { render, staticRenderFns } from "./UGifPicker.vue?vue&type=template&id=0dff808c&scoped=true&"
import script from "./UGifPicker.vue?vue&type=script&lang=js&"
export * from "./UGifPicker.vue?vue&type=script&lang=js&"
import style0 from "./UGifPicker.vue?vue&type=style&index=0&id=0dff808c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff808c",
  null
  
)

export default component.exports